module.exports = __webpack_public_path__ + "img/sub-bell-icon.0fdfe8dd.svg";